




























































































































import {
  BSidebar,
  BForm,
  BButton,
  BFormGroup,
  BFormInput,
  BSpinner,
} from "bootstrap-vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";
import { PaginatedList } from "@/api/models/common/paginatedList";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import { Entreprise } from "@/api/models/adherents/adherent";
import { PtfBeneficiaireBeneficiaire, PtfBeneficiaireBeneficiaireCreate } from "@/api/models/ptfBeneficiaire/Beneficiaire";

@Component({
  components: {
    BSidebar,
    BForm,
    BButton,
    BFormGroup,
    BFormInput,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    SearchableVueSelect,
  },
  name: "create-beneficiaire",
})
export default class EditBeneficiaire extends Vue {
  @Prop({ required: true, type: Boolean })
  isUpdateBeneficiaireSidebarActive!: boolean;
  @Prop({ required: true, type: String }) beneficiaireId!: string;

  loading = false;
  required = required;

  beneficiaire: PtfBeneficiaireBeneficiaire = {}

  entreprises: PaginatedList<Entreprise> = new PaginatedList<Entreprise>();

  refreshIndex = 0;

  resetForm() {
    this.beneficiaire = {};
    this.isUpdateBeneficiaireSidebarActive = false;
  }


  async created() {
    console.log("beneficiaireId", this.beneficiaireId);
    await this.loadBeneficiaire();
  }

  async loadBeneficiaire() {
    this.loading = true;
    await this.$http.ptfBeneficiaire.beneficiaires
      .getBeneficiaireById(this.beneficiaireId)
      .then((res: PtfBeneficiaireBeneficiaire) => {
        this.beneficiaire = res;
        this.loading = false;
        this.refreshIndex++;
      });
  }

  async submit() {
    this.loading = true;
    await this.$http.ptfBeneficiaire.beneficiaires
      .update(this.beneficiaire)
      .then(
        async () => {
          successAlert.fire({
            title: "Mise à jour d'un bénéficiaire",
            text: "Bénéficiaire mis à jour avec succès",
          });
          this.$emit("refetch-data");
          this.$emit("update:is-update-beneficiaire-sidebar-active", false);
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.loading = false;
      });
  }
}
